<template>
  <component :is="way"/>
</template>

<script>
  import basic from './default.vue';

  export default {
    name: 'talentq-index',
    components: {
      default: basic,
    },
    computed: {
      way() {
        return 'default';
      }
    },
  }
</script>
